export const theme = {
  primary: 'hsl(228, 55%, 42%)',
  secondary: 'hsl(228, 55%, 62%)',
  slips: 'hsl(228, 55%, 42%)',
  pits: 'hsl(228, 55%, 42%)',
  hover: '#1565c0',
  users: 'hsl(228, 55%, 42%)',
  white: 'hsl(0, 0%, 100%)',
  red: '#f44336',
  green: '#00796b',
  black: 'hsl(0, 0%, 0%)',
  dark: '#202020',
  grey100: 'hsl(0, 0%, 96%)',
  grey200: 'hsl(0, 0%, 90%)',
  grey300: 'hsl(0, 0%, 70%)',
  grey400: 'hsl(0, 0%, 50%)',
  grey500: '#000000DE',
  light: 300,
  bold: 600,
  fontSize: {
    xxxs: '0.8rem',
    xxs: '1rem',
    xs: '1.2rem',
    s: '1.6rem',
    m: '2.1rem',
    l: '2.4rem',
    xl: '4rem',
  },
};
